export enum Action {
    JOINED,
    LEFT,
    RENAME,
    ME_MSG
}
